import { AppThunk } from '../../../../../store/types';
import { ContentLibEffects } from '../../../../../effects/contentLibEffects';
import { setAuthUserAction, setMainViewMode, setPublicPageAction } from '../../../../../store/general/actions';
import { EMainViewMode } from '../../../../../store/general/types';
import { AuthManager } from '../../../../../../common/utils/auth-manager';
import { updateUserLanguages } from '../../../../../effects/updateUserLanguages';
import { updateUserGroups } from '../../../../../effects/updateUserGroups';
import { getAuthUser, getAuthUserLangCode, getMainViewMode } from '../../../../../store/general/selectors';
import { restoreAppSettings } from '../../../../../effects/prepareAfterOpen';
import { VideoTutorialEffects } from '../../../../../effects/videoTutorialEffects';
import { PhraseDetailsTabEffects } from '../../../../../effects/phraseDetailsTabEffects';
import { setUserGroupsLoadedAction } from '../../../../../store/models/actions';
import { getUserStateStorage } from '../../../../../../common/utils/local-storage/user-state';
import { Navigator } from '../../../../../effects/navigator';
import { findLanguageByCode, getTargetLanguage } from '../../../../../store/models/selectors';
import { LangUtil } from '../../../../../../common/utils/lang-util';
import { ContentLibEvents } from '../../effects';
import { AuthUserEffects } from '../../../../../effects/authUserEffects';
import { ContentLibSelectors } from '../../../../../store/contentLib/selectors';
import { IContentLibOptions } from '../../../../../types/common';
import { PlayListLevelTitles } from '../../../PlayList/PlayListLevelSelect/types';
import { ContentLibActions } from '../../../../../store/contentLib/actions';

export class ContentLibraryDashboardEvents {

  public static onLoad(
    mainViewMode?: EMainViewMode,
    options?: IContentLibOptions,
  ): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      await dispatch(ContentLibEvents.load(mainViewMode, options));
    }
  }

  public static onUnLoad(): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      dispatch(setPublicPageAction(false));
      const mode = getMainViewMode(getState());
      if (mode === EMainViewMode.CONTENT_LIBRARY ||
        mode === EMainViewMode.MY_LIBRARY
      ) {
        dispatch(setMainViewMode(EMainViewMode.DASHBOARD));
      }
    }
  }


}